import { render, staticRenderFns } from "./KurumSorgulaInfo.vue?vue&type=template&id=265eea36"
import script from "./KurumSorgulaInfo.vue?vue&type=script&lang=ts"
export * from "./KurumSorgulaInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports